const CatalogStore = {
    state: {
        quotas: [],
    },
    mutations: {
        // List
        setQuotas(state, data) { state.quotas = data },
    },
    actions: {
        // List
        defineCurrentQuotas({ commit }, value) { commit("setQuotas", value) },
    },
    getters: {
        quotas: state => state.quotas,
    }
}

export default CatalogStore;